export const navCopy = {
  skip_to_content: "Skip to main content",
  nav_documentation: "Documentation",
  nav_documentation_short: "Docs",
  nav_download: "Download",
  nav_connect: "Connect",
  nav_playground: "Playground",
  nav_search_placeholder: "Search Docs",
  nav_search_aria: "Search the TypeScript site",
  nav_beta: "Search the TypeScript site",
  nav_beta_notification:
    "Note: this page is a beta page, don't rely on the URL and <a>file issues on microsoft/TypeScript-Website</a>",
}
